import type { ReactElement } from 'react';
import { CircularProgress, IconButton } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { CircleCheck, Send } from 'lucide-react';

type PpNewsletterFormStatus = {
  formState: 'initial' | 'loading' | 'submitted';
};

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.websiteBrand.primary,
  svg: {
    left: '-1px',
    position: 'relative',
    top: '1px',
  },
  ':hover': {
    backgroundColor: theme.palette.websiteBrand.primary,
  },
}));

export function NewsletterFormStatus({ formState }: PpNewsletterFormStatus): ReactElement {
  const theme = useTheme();
  switch (formState) {
    case 'loading':
      return (
        <IconButton disabled size="small">
          <CircularProgress size={18} />
        </IconButton>
      );
    case 'submitted':
      return (
        <IconButton disabled size="small">
          <CircleCheck color={theme.palette.success.main} size={18} />
        </IconButton>
      );
    default:
      return (
        <StyledIconButton size="small" type="submit">
          <Send color={theme.palette.websiteBrand.greyscale.white} size={18} />
        </StyledIconButton>
      );
  }
}
